<template>
  <div class="emb-contact-wrap">
    <emb-page-title
      :image="bannerSection.Banner_Image_1920x700_px"
      :heading="bannerSection.Title"
      :subHeading="bannerSection.Subtitle"
    ></emb-page-title>
    <div class="emb-contact-content">
      <div class="Contact-page">
        <div class="contact-map">
          <emb-google-map :mapArea="mapSection"></emb-google-map>
        </div>
      </div>
      <div class="contact-info-wrapper">
        <v-container grid-list-xl py-0>
          <div class="section-gap">
            <v-layout row wrap>
              <v-flex sm12 md12 lg5 xl5>
                <div class="sec-title">
                  <h2 class="v-layout justify-start align-center">{{contactSection.Title}}</h2>
                  <h5 class="font-italic mb-6" v-html="contactSection.Description"></h5>
                </div>
                <div class="mb-6">
                  <h3>{{contactSection.Call_Title}}</h3>
                  <a
                    href="contactSection.Description"
                    class="color-inherit"
                  >{{contactSection.Contact_Number}}</a>
                </div>
                <div class="mb-6">
                  <h3>{{contactSection.Mail_Title}}</h3>
                  <a href="mailto:contactSection.Mail" class="color-inherit">{{contactSection.Mail}}</a>
                </div>
                <div class="mb-6">
                  <h3>{{contactSection.Address_Title}}</h3>
                  <p>{{contactSection.Address}}</p>
                </div>
              </v-flex>
              <v-flex sm12 md12 lg7 xl7>
                <div class="sec-title">
                  <h2>{{feedbackSection.Form_Title}}</h2>
                </div>
                <v-form>
                  <v-text-field
                    type="text"
                    v-model="firstName"
                    :placeholder="feedbackSection.Firstname_Placeholder"
                  ></v-text-field>
                  <v-text-field
                    type="text"
                    v-model="lastName"
                    :placeholder="feedbackSection.Lastname_Placeholder"
                  ></v-text-field>
                  <v-text-field
                    type="email"
                    v-model="email"
                    :placeholder="feedbackSection.Email_Placeholder"
                  ></v-text-field>
                  <v-text-field
                    type="text"
                    v-model="subject"
                    :placeholder="feedbackSection.Subject_Placeholder"
                  ></v-text-field>
                  <v-textarea
                    rows="2"
                    v-model="message"
                    :label="feedbackSection.Message_Placeholder"
                  ></v-textarea>
                  <v-btn
                    class="accent mx-0 mt-4"
                    large
                    @click.stop.prevent="saveDetails"
                  >{{feedbackSection.Button_Label}}</v-btn>
                </v-form>
              </v-flex>
            </v-layout>
          </div>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
// import api from "Api";
import gettingRestClientObject from "../../services/utils/cms-helper";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
Vue.use(VueMoment, {
  moment,
});

export default {
  data() {
    return {
      valid: false,
      emailRules: [
        // (v) => !!v || "E-mail is required",
        // (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      inputRules: {
        // basictextRules: [(v) => !!v || "This field should not be empty"],
      },
      cmsRequestFunctions: "",
      bannerSection: "",
      contactSection: "",
      contact: "",
      feedbackSection: "",
      mapSection: "",
      firstName: "",
      lastName: "",
      email: "",
      subject: "",
      message: "",
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    if (sessionStorage.validationItems == undefined) {
      this.cmsRequestFunctions.getValidationMsgs();
    }

    this.emailRules = [
      (v) => !!v || this.cmsRequestFunctions.getValidationMsgByCode("M026"),
      (v) =>
        /.+@.+/.test(v) ||
        this.cmsRequestFunctions.getValidationMsgByCode("M010"),
    ];
    this.inputRules = {
      basictextRules: [
        (v) => !!v || this.cmsRequestFunctions.getValidationMsgByCode("M026"),
      ],
    };
    this.getPageData();
  },
  computed: {
    ...mapGetters(["selectedLocale"]),
  },
  watch: {
    selectedLocale: function () {
      this.getPageData();
    },
  },
  methods: {
    saveDetails: async function () {
      //   this.$refs.form.validate()
      var self = this;
      if (!self.firstName) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M005"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      if (!self.lastName) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M006"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      if (!self.email) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M007"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      var emailPat = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
      var matchArray = self.email.match(emailPat);
      if (matchArray == null) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M010"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      if (!self.subject) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M012"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      if (!self.message) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M013"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      } else {
        let requestedDate = moment(String(new Date())).format(
          "YYYY-MM-DDThh:mm:ss"
        );
        var sendingRequest = {
          type: "User Enquiries",
          keyword1: self.firstName,
          keyword2: self.lastName,
          keyword3: self.email,
          text1: self.subject,
          text2: self.message,
          date1: requestedDate,
        };
        let responseObject = await self.cmsRequestFunctions.cmsFormData(
          sendingRequest
        );
        await self.sendMail();
        try {
          let insertID = Number(responseObject);
          console.log(insertID);
          //   var emailApi = ServiceUrls.emailServices.emailApi;
          //   sendMailService(emailApi, postData);
          //   sendMailService(emailApi, custmail);
          self.firstName = "";
          self.lastName = "";
          self.email = "";
          self.subject = "";
          (self.message = ""),
            self.$snotify.success(
              self.cmsRequestFunctions.getValidationMsgByCode("M038"),
              {
                closeOnClick: false,
                pauseOnHover: false,
                timeout: 2000,
                showProgressBar: false,
              }
            );
          // Vue.$toast.success(
          //   self.cmsRequestFunctions.getValidationMsgByCode("M014")
          // );
        } catch (e) {
          console.log(e);
        }
      }
    },
    sendMail: async function () {
      var self = this;
      var toMails=Array.isArray(this.email) ? this.email : [this.email];
      var custAcknowledgementMail = {
        type: "UserAddedRequest",
        fromEmail: "shibu@sgtechconsultants.com",
        toEmails: toMails,
        logo:"https://ov-cms.s3.ap-south-1.amazonaws.com/B2B/AdminPanel/CMS/AGY20518/Images/25082020105742.png",
        agencyName: "Demo Address",
        agencyAddress:"Demo Address , Airport road",
        personName: self.firstName || "",
        primaryColor: "#ffffff",
        secondaryColor: "#323f99",
      };
      let orderSuccess = await self.cmsRequestFunctions.sendMail(
        custAcknowledgementMail
      );
      console.log(orderSuccess);
    },
    getPageData: function () {
      var self = this;

      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "05 Contact Us/05 Contact Us/05 Contact Us.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;

          if (res.area_List) {
            var bannerArea = self.cmsRequestFunctions.pluck(
              "Banner_Section",
              res.area_List
            );
            self.bannerSection = self.cmsRequestFunctions.getAllMapData(
              bannerArea[0].component
            );
            var contact = self.cmsRequestFunctions.pluck(
              "Contact_Info_Section",
              res.area_List
            );
            self.contactSection = self.cmsRequestFunctions.getAllMapData(
              contact[0].component
            );
            var feedback = self.cmsRequestFunctions.pluck(
              "Feedback_Section",
              res.area_List
            );
            self.feedbackSection = self.cmsRequestFunctions.getAllMapData(
              feedback[0].component
            );
            var map = self.cmsRequestFunctions.pluck(
              "Map_Section",
              res.area_List
            );
            self.mapSection = self.cmsRequestFunctions.getAllMapData(
              map[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
  },
};
</script>

